<label [for]="fieldId" *ngIf="label"
       [class.mandatory]="isMandatory()">
  {{ label }}
</label>
<input [id]="fieldId"
       [type]="type"
       [formControl]="control"
       [attr.maxlength]="getMaxLength()"
       [class.is-invalid]="isInvalid()"
       appToUpperCaseConditionally [toUpperCaseEnabled]="toUpperCaseEnabled"
       appSaveLastFocussedConditionally [saveLastFocussedEnabled]="saveLastFocusedEnabled"
       class="form-control form-control-sm"
       [ngbPopover]="assistantServiceEnabled ? popOverName : ''">
<ng-template #popOverName>
  <app-assistant (assistantDisabled)="disableAssistant()">
    <ng-content></ng-content>
  </app-assistant>
</ng-template>
